export default [
    {
        path: "cookie-scanner-result",
        alias: ['slapuku-nuskaitymo-rezultatai'],
        meta: {
            layout: () => import("../layouts/NoHeader.vue"),
        },
        component: () => import("../views/WebsiteScan/Wrapper.vue"),
        children: [
            {
                path: ":uuid",
                name: "website-scan-result",
                meta: {
                    step: 1,
                },
                component: () => import("../views/WebsiteScan/Result.vue"),
            }
        ],
    },
    {
        path: "accessibility-scanner-result",
        alias: ['prieinamumo-nuskaitymo-rezultatai'],
        meta: {
            layout: () => import("../layouts/NoHeader.vue"),
        },
        component: () => import("../views/A11yScan/Wrapper.vue"),
        children: [
            {
                path: ":uuid",
                name: "a11y-scan-result",
                meta: {
                    step: 1,
                },
                component: () => import("../views/A11yScan/Result.vue"),
            }
        ],
    },
];
